import { render } from "./Step4.vue?vue&type=template&id=34ef20f6"
import script from "./Step4.vue?vue&type=script&lang=ts"
export * from "./Step4.vue?vue&type=script&lang=ts"

import "./Step4.vue?vue&type=style&index=0&id=34ef20f6&lang=scss"
script.render = render

export default script